import {
  ALLOWED_LOCALES,
  type AvailableLanguage,
  DEFAULT_LOCALE,
} from 'i18n/useTranslations';
import { detectBrowserLanguage } from 'lib/detectBrowserLanguage';

export const getAllowedLocales = (locale: string | null) => {
  if (locale?.startsWith('en')) {
    return DEFAULT_LOCALE;
  }
  return ALLOWED_LOCALES.includes(locale || '')
    ? (locale as AvailableLanguage)
    : null;
};

export const getSafeLocaleFromUrl = (pathname: string) => {
  const localeFromUrl = pathname.split('/')[1] ?? '';
  const safeLocaleFromUrl = getAllowedLocales(localeFromUrl);
  const safeBrowserLocale = getAllowedLocales(detectBrowserLanguage());
  return safeLocaleFromUrl || safeBrowserLocale || DEFAULT_LOCALE;
};
